import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import { push } from 'react-router-redux';
import Content from '../../../layout/Content';
import {
  clearDriverCommission,
  getDriverCommission,
  updateDriverCommission,
} from '../../../../actions';
import { DRIVER_COMMISSION_PATH } from '../../../../config/paths';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import DriverCommissionForm from './DriverCommissionForm';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';

const EditDriverCommission = ({
  breadcrumbs,
  dispatchUpdateDriverCommission,
  dispatchGetDriverCommission,
  dispatchClearDriverCommission,
  match: {
    params: { id },
  },
  driverCommission,
  loading,
  dispatchPush,
}) => {
  useLayoutEffect(() => {
    dispatchGetDriverCommission(id);
    return () => dispatchClearDriverCommission();
  }, []);

  const onSubmit = async (formValues) => {
    const { name, description, baseCommission, driverCommissionRangeList } =
      formValues;

    const newFormValues = {
      id,
      name,
      description,
      baseCommission,
      driverCommissionRangeList: driverCommissionRangeList.map(
        ({ commission, startRange, driverType }) => ({
          commission,
          startRange,
          driverTypeId: driverType ? driverType.value : null,
        }),
      )
    };

    await dispatchUpdateDriverCommission(id, newFormValues);
    dispatchPush(`${DRIVER_COMMISSION_PATH}/${id}`);
  };

  const generateInitialValues = ({
    name,
    description,
    baseCommission,
    driverCommissionRangeList
  }) => ({
    name,
    description,
    baseCommission,
    driverCommissionRangeList: driverCommissionRangeList.map(
      ({ commission, startRange, driverType }) => ({
        commission,
        startRange,
        driverType: driverType
          ? { value: driverType.id, label: driverType.name }
          : null,
      }),
    )
  });

  let content = null;

  if (loading) {
    content = <Loader />;
  } else if (driverCommission.isEmpty()) {
    content = <NoDataResource returnPage={DRIVER_COMMISSION_PATH} />;
  } else {
    const driverCommissionJson = driverCommission.toJS();
    content = (
      <DriverCommissionForm
        onSubmit={onSubmit}
        initialValues={generateInitialValues(driverCommissionJson)}
      />
    );
  }

  return (
    <Content
      title="Editar Comisión de Conductor"
      subtitle="Editar comisión de conductor"
      content={content}
      breadcrumbs={breadcrumbs}
    />
  );
};

EditDriverCommission.propTypes = {
  match: matchPropTypes.isRequired,
  dispatchUpdateDriverCommission: PropTypes.func.isRequired,
  dispatchGetDriverCommission: PropTypes.func.isRequired,
  driverCommission: PropTypes.instanceOf(Immutable.Map).isRequired,
  loading: PropTypes.bool,
  dispatchClearDriverCommission: PropTypes.func.isRequired,
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPush: PropTypes.func.isRequired,
};

EditDriverCommission.defaultProps = {
  loading: false,
};

const mapStateToProps = (
  { HumanResourcesUnit },
  {
    match: {
      params: { id },
    },
  },
) => ({
  breadcrumbs: [
    ...HumanResourcesUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Comisiones de Conductores',
      href: DRIVER_COMMISSION_PATH,
    },
    {
      text: 'Comisión de Conductor',
      href: `${DRIVER_COMMISSION_PATH}/${id}`,
    },
    {
      text: 'Editar',
      href: '',
    },
  ],
  driverCommission: HumanResourcesUnit.DriverCommission.getIn([
    'current',
    'content',
  ]),
  loading: !HumanResourcesUnit.DriverCommission.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

const mapDispatchToProps = {
  dispatchUpdateDriverCommission: updateDriverCommission,
  dispatchGetDriverCommission: getDriverCommission,
  dispatchClearDriverCommission: clearDriverCommission,
  dispatchPush: push,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditDriverCommission);
